export default ({ projectAvailability, totalHoursSpendingOnProjects, partialityAmount }) => {
  if (typeof projectAvailability !== 'number' || typeof totalHoursSpendingOnProjects !== 'number') {
    return null;
  }

  const newProjectHours = parseInt(`${partialityAmount || '0'}`);

  return projectAvailability - totalHoursSpendingOnProjects - newProjectHours < 0;
};
